import React from "react";
import Head from "../../football/match/Head";
import IceHockeyDetailInfo from "../../ice-hockey/IceHockeyDetailInfo";
import IceHockeyStats from "../../ice-hockey/IceHockeyStats";
import IceHockeyH2H from "../../ice-hockey/IceHockeyH2H";
import IceHockeyMatchTable from "../../ice-hockey/IceHockeyMatchTable";

const IceHockeyMatchWidgetWrap = (props) => {
  const {
    dataId,
    dataType,
    head,
    data,
    headData,
    sport,
    difference,
    loadCSS,
    dataClient,
    websiteBaseUrl,
    dataPath,
    dataTitle,
    socketUrl,
    channel,
    event,
  } = props;


  const renderHeadWrap = (currentTab, children) =>
    head ? (
      <Head
        matchDetail={headData}
        difference={difference}
        sport={sport}
        dataClient={dataClient}
        id={dataId}
        currentTab={currentTab}
        websiteBaseUrl={websiteBaseUrl}
        dataPath={dataPath}
        title={dataTitle}
        socketUrl={socketUrl}
        channel={channel}
        event={event}
      >
        {children}
      </Head>
    ) : (
      children
    );

  switch (dataType) {
    case "icehockey-match-info":
      return renderHeadWrap("info",
        <IceHockeyDetailInfo
          ServerData={headData?.data}
          loadCSS={loadCSS}
          dataClient={dataClient}
          difference={difference}
          title={dataTitle}
          sport={sport}
          summary={data?.data}
          websiteBaseUrl={websiteBaseUrl}
          dataPath={dataPath}
        />
      );
    case "icehockey-match":
      return (head && (<Head
        matchDetail={headData}
        difference={difference}
        sport={sport}
        dataClient={dataClient}
        id={dataId}
        websiteBaseUrl={websiteBaseUrl}
        dataPath={dataPath}
        title={dataTitle}
      />));
    case "icehockey-match-stats":
      return renderHeadWrap("stats",
        <IceHockeyStats
          data={data?.data}
          loadCSS={loadCSS}
          dataClient={dataClient}
          title={dataTitle}
        />
      );
    case "icehockey-match-h2h":
      return renderHeadWrap("h2h",
        <IceHockeyH2H
          data={data?.data}
          loadCSS={loadCSS}
          dataClient={dataClient}
          title={dataTitle}
          sport={sport}
        />
      );
    case "icehockey-match-table":
      return renderHeadWrap("table",
        <IceHockeyMatchTable
          data={data?.data}
          loadCSS={loadCSS}
          dataClient={dataClient}
          title={dataTitle}
          sport={sport}
          websiteBaseUrl={websiteBaseUrl}
          dataPath={dataPath}
        />
      );
    default:
      return <h1>Ice Hockey Match Widget Not Found!</h1>;
  }
};

export default IceHockeyMatchWidgetWrap;
